(function () {
  var root = document.getElementById('te-quiz');
  if (!root) return;

  var dataEl = document.getElementById('te-quiz-data');
  var products = [];
  try {
    products = JSON.parse(dataEl.textContent || '[]');
  } catch (e) {
    products = [];
  }

  var state = { uso: null, talla: null, silueta: null, tejido: null, color: null };
  var currentStep = 1;
  var TOTAL_STEPS = 4;

  var steps = {
    1: root.querySelector('[data-step="1"]'),
    2: root.querySelector('[data-step="2"]'),
    3: root.querySelector('[data-step="3"]'),
    4: root.querySelector('[data-step="4"]'),
    results: root.querySelector('[data-step="results"]')
  };
  var progressSteps = root.querySelectorAll('[data-progress-step]');

  function showStep(step) {
    Object.keys(steps).forEach(function (key) {
      steps[key].hidden = String(key) !== String(step);
    });
    currentStep = step;
    updateProgress();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function updateProgress() {
    var stepNum = typeof currentStep === 'number' ? currentStep : TOTAL_STEPS + 1;
    progressSteps.forEach(function (el, i) {
      el.classList.toggle('is-done', i + 1 < stepNum);
      el.classList.toggle('is-current', i + 1 === stepNum);
    });
  }

  function selectSingle(container, question, value, onComplete) {
    container.querySelectorAll('.te-quiz__option, .te-quiz__pill').forEach(function (btn) {
      btn.classList.remove('is-selected');
    });
    state[question] = value;
    onComplete();
  }

  // Step 1: uso (auto-advance)
  root.querySelectorAll('[data-question="uso"] .te-quiz__option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.uso = btn.dataset.value;
      showStep(2);
    });
  });

  // Step 2: talla + silueta (both required, manual "Continuar")
  var nextBtn = root.querySelector('[data-step="2"] [data-next]');
  function checkStep2Complete() {
    nextBtn.disabled = !(state.talla && state.silueta);
  }
  root.querySelectorAll('[data-question="talla"] .te-quiz__pill').forEach(function (btn) {
    btn.addEventListener('click', function () {
      root.querySelectorAll('[data-question="talla"] .te-quiz__pill').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');
      state.talla = btn.dataset.value;
      checkStep2Complete();
    });
  });
  root.querySelectorAll('[data-question="silueta"] .te-quiz__pill').forEach(function (btn) {
    btn.addEventListener('click', function () {
      root.querySelectorAll('[data-question="silueta"] .te-quiz__pill').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');
      state.silueta = btn.dataset.value;
      checkStep2Complete();
    });
  });
  nextBtn.addEventListener('click', function () {
    if (!nextBtn.disabled) showStep(3);
  });

  // Step 3: tejido (auto-advance)
  root.querySelectorAll('[data-question="tejido"] .te-quiz__option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.tejido = btn.dataset.value;
      showStep(4);
    });
  });

  // Step 4: color (auto-advance to results)
  root.querySelectorAll('[data-question="color"] .te-quiz__option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.color = btn.dataset.value;
      showResults();
    });
  });

  // Back buttons
  root.querySelectorAll('[data-back]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var step = parseInt(btn.closest('.te-quiz__step').dataset.step, 10);
      showStep(step - 1);
    });
  });

  // Restart
  root.querySelector('[data-restart]').addEventListener('click', function () {
    state = { uso: null, talla: null, silueta: null, tejido: null, color: null };
    root.querySelectorAll('.te-quiz__option, .te-quiz__pill').forEach(function (btn) {
      btn.classList.remove('is-selected');
    });
    nextBtn.disabled = true;
    showStep(1);
  });

  function variantMatches(product) {
    return product.variants.some(function (v) {
      return v.silueta === state.silueta && v.talla === state.talla && v.available;
    });
  }

  function filterProducts(relax) {
    return products.filter(function (p) {
      if (p.estilo && p.estilo !== state.uso) return false;
      if (!relax) {
        if (p.tejido && p.tejido !== state.tejido) return false;
        if (p.color && p.color !== state.color) return false;
      }
      return variantMatches(p);
    });
  }

  function renderCard(product) {
    var a = document.createElement('a');
    a.className = 'te-quiz__card';
    a.href = '/products/' + product.handle;

    var imgWrap = document.createElement('div');
    imgWrap.className = 'te-quiz__card-image';
    var img = document.createElement('img');
    img.src = product.image;
    img.alt = product.title;
    img.loading = 'lazy';
    imgWrap.appendChild(img);

    var title = document.createElement('p');
    title.className = 'te-quiz__card-title';
    title.textContent = product.title;

    var price = document.createElement('p');
    price.className = 'te-quiz__card-price';
    price.textContent = product.price;

    a.appendChild(imgWrap);
    a.appendChild(title);
    a.appendChild(price);
    return a;
  }

  function showResults() {
    var grid = root.querySelector('[data-results-grid]');
    var note = root.querySelector('[data-results-note]');
    var empty = root.querySelector('[data-results-empty]');
    var heading = root.querySelector('[data-results-heading]');
    grid.innerHTML = '';
    note.hidden = true;
    empty.hidden = true;

    var results = filterProducts(false);
    var relaxed = false;
    if (results.length === 0) {
      results = filterProducts(true);
      relaxed = true;
    }

    if (results.length === 0) {
      heading.textContent = 'Su selección';
      empty.hidden = false;
    } else {
      heading.textContent = relaxed ? 'Opciones cercanas a lo que buscaba' : 'Su camisa ideal';
      if (relaxed) {
        note.hidden = false;
        note.textContent = 'No encontramos ese tejido y color exactos en su talla, pero estas camisas sí están disponibles:';
      }
      results.forEach(function (p) {
        grid.appendChild(renderCard(p));
      });
    }

    showStep('results');
  }
})();
